<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
      <el-table-column align="center" label="桥梁名称" prop="bridgeName" width="150"></el-table-column>
      <el-table-column align="center" label="昨日有效数据量" prop="lastDayDataCount"></el-table-column>
      <el-table-column align="center" label="预估有效数据量" prop="lastDayDataCount_expected"></el-table-column>
      <el-table-column align="center" label="昨日有效数据比例">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.lastDayPercentageTagType">{{ scope.row.LastDayDataPercentage }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="昨日连通质量">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.lastDayHistoryScoreTagType">{{ scope.row.lastDayCommHistoryScore }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="当前有效字段数" prop="currentValidCommCount"></el-table-column>
      <el-table-column align="center" label="桥梁总字段数" prop="currentValidCommCount_expected"></el-table-column>
      <el-table-column align="center" label="当前有效字段比例">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.currentValidCommPercentageTagType">{{
            scope.row.CurrentValidCommPercentage
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="triggerStationDialog(scope.row.bridgeId)" class="table-button">设备组</el-button>
          <el-button size="small" type="primary" @click="hrefToDetailPage(scope.row.bridgeId)" class="table-button">设备</el-button>
          <el-button size="small" type="primary" @click="hrefToCommHistoryPage(scope.row.bridgeId)" class="table-button">历史联通质量</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>

    <!-- 设备组联通情况弹窗 -->
    <el-dialog :visible.sync="stationCommStatusDialogVisible" width="80%" top="2%" :show-close="false" v-loading="stationCommStatusDialogLoading">
      <div class="station-table-header">
        <div class="station-table-header-left">{{ stationTableReport.bridgeName }}</div>
        <div class="station-table-header-right">
          <span class="table-command-item-key dh-right">昨日数据量比例: </span>
          <el-tag class="percentage-tag dh-right" effect="dark" :type="stationTableReport.lastDayTagType">{{
            stationTableReport.LastDayDataPercentage
          }}</el-tag>

          <span class="table-command-item-key dh-right">当前字段比例: </span>
          <el-tag class="percentage-tag dh-right" effect="dark" :type="stationTableReport.currentTagType">{{
            stationTableReport.CurrentValidCommPercentage
          }}</el-tag>
        </div>
      </div>
      <el-table :data="stationTableData" style="width: 100%" :max-height="tableMaxHeight">
        <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
        <el-table-column align="center" label="设备组名称" prop="stationName" width="150"></el-table-column>
        <el-table-column align="center" label="昨日有效数据量" prop="lastDayDataCount"></el-table-column>
        <el-table-column align="center" label="预估有效数据量" prop="lastDayDataCount_expected"></el-table-column>
        <el-table-column align="center" label="昨日有效数据比例">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.lastDayPercentageTagType">{{ scope.row.LastDayDataPercentage }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="当前有效字段数" prop="currentValidCommCount"></el-table-column>
        <el-table-column align="center" label="设备组总字段数" prop="currentValidCommCount_expected"></el-table-column>
        <el-table-column align="center" label="当前有效字段比例">
          <template slot-scope="scope">
            <el-tag class="percentage-tag" effect="dark" :type="scope.row.currentValidCommPercentageTagType">{{
              scope.row.CurrentValidCommPercentage
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "RemoteHistory",
  data() {
    return {
      timer: null,
      tableData: [],
      fullData: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 0,
      currentPage: 1,
      pageSize: 20,
      bridgeId: "",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,

      stationCommStatusDialogVisible: false,
      stationCommStatusDialogLoading: false,
      stationTableData: null,
      stationTableReport: {
        bridgeName: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    this.getDataList();

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    bridgeId() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.bridgeId = this.bridgeId;
      this.$router.replace({ query: query });

      this.refreshData();
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getPageData();
    },
    getDataList() {
      this.$http.get("/socketCommStatus/GetSocketCommStatusReport").then((res) => {
        let dataList = res.data;
        let index = 0;
        for (let dataItem of dataList) {
          index += 1;
          dataItem.index = index;

          dataItem.lastDayPercentageTagType = "info";
          dataItem.currentValidCommPercentageTagType = "info";
          dataItem.lastDayHistoryScoreTagType = "info";

          if (dataItem.LastDayDataPercentage > 90) {
            dataItem.lastDayPercentageTagType = "success";
          } else if (dataItem.LastDayDataPercentage > 50) {
            dataItem.lastDayPercentageTagType = "warning";
          } else {
            dataItem.lastDayPercentageTagType = "danger";
          }
          if (dataItem.LastDayDataPercentage > 100) {
            dataItem.LastDayDataPercentage = 100;
          }

          if (dataItem.CurrentValidCommPercentage > 90) {
            dataItem.currentValidCommPercentageTagType = "success";
          } else if (dataItem.CurrentValidCommPercentage > 50) {
            dataItem.currentValidCommPercentageTagType = "warning";
          } else {
            dataItem.currentValidCommPercentageTagType = "danger";
          }

          if (dataItem.lastDayCommHistoryScore > 90) {
            dataItem.lastDayHistoryScoreTagType = "success";
          } else if (dataItem.lastDayCommHistoryScore > 50) {
            dataItem.lastDayHistoryScoreTagType = "warning";
          } else {
            dataItem.lastDayHistoryScoreTagType = "danger";
          }

          dataItem.LastDayDataPercentage = dataItem.LastDayDataPercentage + "%";
          dataItem.CurrentValidCommPercentage = dataItem.CurrentValidCommPercentage + "%";

          dataItem.lastDayDataCount_expected = parseInt(dataItem.lastDayDataCount_expected);
        }

        this.fullData = dataList;
        this.totalCount = dataList.length;

        this.getPageData();
      });
    },
    getPageData() {
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize - 1;

      let dataList = [];
      for (let i = startIndex; i <= endIndex; i++) {
        if (i >= this.fullData.length) {
          break;
        }

        dataList.push(this.fullData[i]);
      }

      this.tableData = dataList;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    triggerStationDialog(bridgeId) {
      this.stationCommStatusDialogLoading = true;
      this.stationTableData = null;
      this.stationTableReport = null;
      this.stationCommStatusDialogVisible = true;

      let bridgeQuery = this.$http.get("/socketCommStatus/GetSocketCommStatusReport?bridgeId=" + bridgeId);
      let stationQuery = this.$http.get("/socketCommStatus/GetSocketCommStatusReportForStation?bridgeId=" + bridgeId);
      this.$http.all([bridgeQuery, stationQuery]).then(
        this.$http.spread((bridgeRes, stationRes) => {
          this.stationTableReport = bridgeRes.data[0];

          this.stationTableReport.currentTagType = "info";
          if (this.stationTableReport.CurrentValidCommPercentage > 90) {
            this.stationTableReport.currentTagType = "success";
          } else if (this.stationTableReport.CurrentValidCommPercentage > 50) {
            this.stationTableReport.currentTagType = "warning";
          } else {
            this.stationTableReport.currentTagType = "danger";
          }

          this.stationTableReport.lastDayTagType = "info";
          if (this.stationTableReport.LastDayDataPercentage > 90) {
            this.stationTableReport.lastDayTagType = "success";
          } else if (this.stationTableReport.LastDayDataPercentage > 50) {
            this.stationTableReport.lastDayTagType = "warning";
          } else {
            this.stationTableReport.lastDayTagType = "danger";
          }
          if (this.stationTableReport.LastDayDataPercentage > 100) {
            this.stationTableReport.LastDayDataPercentage = 100;
          }

          let dataList = stationRes.data;
          let index = 0;
          for (let dataItem of dataList) {
            index += 1;
            dataItem.index = index;

            dataItem.lastDayPercentageTagType = "info";
            dataItem.currentValidCommPercentageTagType = "info";
            dataItem.lastDayHistoryScoreTagType = "info";
            dataItem.isEnvironmentStation = false;

            if (dataItem.LastDayDataPercentage > 90) {
              dataItem.lastDayPercentageTagType = "success";
            } else if (dataItem.LastDayDataPercentage > 50) {
              dataItem.lastDayPercentageTagType = "warning";
            } else {
              dataItem.lastDayPercentageTagType = "danger";
            }
            if (dataItem.LastDayDataPercentage > 100) {
              dataItem.LastDayDataPercentage = 100;
            }
            if (dataItem.stationName === "环境信息" && dataItem.lastDayDataCount === 0 && dataItem.lastDayDataCount_expected === 0) {
              dataItem.LastDayDataPercentage = "N/A";
              dataItem.lastDayPercentageTagType = "success";
              dataItem.isEnvironmentStation = true;
            }

            if (dataItem.CurrentValidCommPercentage > 90) {
              dataItem.currentValidCommPercentageTagType = "success";
            } else if (dataItem.CurrentValidCommPercentage > 50) {
              dataItem.currentValidCommPercentageTagType = "warning";
            } else {
              dataItem.currentValidCommPercentageTagType = "danger";
            }

            if (!dataItem.isEnvironmentStation) {
              dataItem.LastDayDataPercentage = dataItem.LastDayDataPercentage + "%";
            }
            dataItem.CurrentValidCommPercentage = dataItem.CurrentValidCommPercentage + "%";

            dataItem.lastDayDataCount_expected = parseInt(dataItem.lastDayDataCount_expected);
          }

          this.stationTableData = dataList;

          this.$nextTick(() => {
            this.stationCommStatusDialogLoading = false;
          });
        })
      );
    },
    hrefToDetailPage(bridgeId) {
      this.$router.push("/admin/socketCommStatusDetail?bridgeId=" + bridgeId);
    },
    hrefToCommHistoryPage(bridgeId) {
      this.$router.push("/admin/socketCommHistoryDetail?bridgeId=" + bridgeId);
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
    // generateReport() {
    //   try {
    //     if (!this.tableData || !this.tableData.length || this.tableData.length === 0) {
    //       throw "数据列表为空";
    //     }

    //     let currentWarning = [];
    //     let currentError = [];
    //     let historyWarning = [];
    //     let historyError = [];
    //     this.tableData.forEach((item) => {
    //       if (item.currentValidCommPercentageTagType === "warning") {
    //         currentWarning.push(item);
    //       } else if (item.currentValidCommPercentageTagType === "danger") {
    //         currentError.push(item);
    //       }

    //       if (item.lastDayHistoryScoreTagType === "warning") {
    //         historyWarning.push(item);
    //       } else if (item.lastDayHistoryScoreTagType === "danger") {
    //         historyError.push(item);
    //       }
    //     });

    //     let result = "";
    //     if (currentWarning.length === 0 && currentError.length === 0 && historyWarning.length === 0 && historyError.length === 0) {
    //       result = "今日无报警";
    //     } else {
    //       //current
    //       if (currentWarning.length === 0 && currentError.length === 0) {
    //         result = result + "当前无报警. \n";
    //       } else {
    //         if (currentError.length > 0) {
    //           result = result + "当前红色报警: ";

    //           let isFirst = true;
    //           currentError.forEach((item) => {
    //             if (isFirst) {
    //               isFirst = false;
    //             } else {
    //               result = result + ", ";
    //             }

    //             result = result + item.bridgeName;
    //           });
    //           result = result + ".\n";
    //         }

    //         if (currentWarning.length > 0) {
    //           result = result + "当前黄色报警: ";

    //           let isFirst = true;
    //           currentWarning.forEach((item) => {
    //             if (isFirst) {
    //               isFirst = false;
    //             } else {
    //               result = result + ", ";
    //             }

    //             result = result + item.bridgeName;
    //           });
    //           result = result + ".\n";
    //         }
    //       }

    //       if (historyWarning.length > 0 || historyError.length > 0) {
    //         if (historyError.length > 0) {
    //           result = result + "昨日分数红色报警: ";

    //           let isFirst = true;
    //           historyError.forEach((item) => {
    //             if (isFirst) {
    //               isFirst = false;
    //             } else {
    //               result = result + ", ";
    //             }

    //             result = result + item.bridgeName;
    //           });
    //           result = result + ".\n";
    //         }

    //         if (historyWarning.length > 0) {
    //           result = result + "昨日分数黄色报警: ";

    //           let isFirst = true;
    //           historyWarning.forEach((item) => {
    //             if (isFirst) {
    //               isFirst = false;
    //             } else {
    //               result = result + ", ";
    //             }

    //             result = result + item.bridgeName;
    //           });
    //           result = result + ".\n";
    //         }
    //       }
    //     }

    //     this.copyTextToClipboard(result).then(() => {
    //       this.$message({
    //         message: "今日报告已复制剪切板.",
    //         type: "success",
    //       });
    //     });
    //   } catch (e) {
    //     let message = "今日报告生成失败. " + e;

    //     this.copyTextToClipboard(message).then(() => {
    //       this.$message({
    //         message: message,
    //         type: "warning",
    //       });
    //     });
    //   }
    // },
    // async copyTextToClipboard(text) {
    //   if (navigator.clipboard && navigator.permissions) {
    //     await navigator.clipboard.writeText(text);
    //     console.log("copy clipboard navigator");
    //   } else {
    //     const textArea = document.createElement("textArea");
    //     textArea.value = text;
    //     textArea.style.width = 0;
    //     textArea.style.position = "fixed";
    //     textArea.style.left = "-999px";
    //     textArea.style.top = "10px";
    //     textArea.setAttribute("readonly", "readonly");
    //     document.body.appendChild(textArea);

    //     textArea.select();
    //     document.execCommand("copy");
    //     document.body.removeChild(textArea);
    //     console.log("copy clipboard exec command");
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
  .table-command-button {
    margin-right: 40px;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}
.percentage-tag {
  min-width: 75px;
}

.station-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.station-table-header-left {
  margin-left: 20px;
  font-size: 20px;
}

.station-table-header-right {
  display: flex;
  align-items: center;
  justify-content: end;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
